import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TimeKeeperSystemTypeState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: TimeKeeperSystemTypeState = {
  data: [],
  isLoading: false,
  error: null,
};

const timeKeepersystemTypeSlice = createSlice({
  name: 'timeKeeperSystemTypes',
  initialState,
  reducers: {
    setTimeKeeperSystemTypes: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setTimeKeeperSystemTypesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setTimeKeeperSystemTypesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setTimeKeeperSystemTypes, setTimeKeeperSystemTypesLoading, setTimeKeeperSystemTypesError } =
  timeKeepersystemTypeSlice.actions;

export default timeKeepersystemTypeSlice.reducer;
